import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@app/shared/providers/AuthProvider';
import { useAppSelector } from '@app/store/hooks';
import { selectIsAuthenticated } from '@app/store/selectors';
import { Page } from '@app/routes';
import { Loading } from '@app/shared/ui/organisms/Common';

export const RequireAuth = () => {
  const { isLoading } = useAuth();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isLoading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to={Page.AUTH} replace />;
  }

  return <Outlet />;
};
